<template>
  <svg
    width="56"
    height="56"
    viewBox="0 0 56 56"
    :fill="fill"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M21.8333 38.8805L39.0291 28.0005L21.8333 17.1204V38.8805ZM28.0093 55.3755C24.1736 55.3755 20.5661 54.6577 17.1868 53.222C13.8095 51.7843 10.8711 49.8336 8.3715 47.3698C5.87194 44.9081 3.89347 42.0124 2.43608 38.6828C0.978695 35.3532 0.25 31.7955 0.25 28.0096C0.25 24.2258 0.977666 20.667 2.433 17.3334C3.89039 14.0017 5.86783 11.103 8.36533 8.63724C10.8608 6.17146 13.7961 4.21972 17.1713 2.78203C20.5466 1.34434 24.153 0.625488 27.9907 0.625488C31.8264 0.625488 35.4339 1.34332 38.8132 2.77899C42.1905 4.21668 45.1289 6.16741 47.6285 8.63116C50.1281 11.0929 52.1065 13.9885 53.5639 17.3182C55.0213 20.6478 55.75 24.2055 55.75 27.9914C55.75 31.7752 55.0223 35.3339 53.567 38.6676C52.1096 41.9993 50.1322 44.898 47.6347 47.3637C45.1392 49.8295 42.2039 51.7813 38.8287 53.2189C35.4534 54.6566 31.847 55.3755 28.0093 55.3755ZM28 52.3338C34.8861 52.3338 40.7187 49.9765 45.4979 45.2619C50.2771 40.5474 52.6667 34.7935 52.6667 28.0005C52.6667 21.2074 50.2771 15.4536 45.4979 10.739C40.7187 6.02445 34.8861 3.66716 28 3.66716C21.1139 3.66716 15.2812 6.02445 10.5021 10.739C5.72292 15.4536 3.33333 21.2074 3.33333 28.0005C3.33333 34.7935 5.72292 40.5474 10.5021 45.2619C15.2812 49.9765 21.1139 52.3338 28 52.3338Z"/>
  </svg>
</template>

<script>
export default {
  name: "PlayVideoIcon",
  props: {
    fill: {
      type: String,
      default: '#fff'
    },
  }
}
</script>
